export default "__VITE_ASSET__CF9LEyZ0__"